import { Controller } from "@hotwired/stimulus"

// Auto-submits the closest form when an input changes.
// Usage: data-action="change->auto-submit-form#submit"
export default class extends Controller {
  submit() {
    const form = this.element.closest("form")

    form.classList.remove("is-auto-submitting")
    void form.offsetWidth
    form.classList.add("is-auto-submitting")

    window.setTimeout(() => {
      form.classList.remove("is-auto-submitting")
    }, 420)

    form.requestSubmit()
  }
}
